import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

// Import CSS files
import '../assets/css/lineicons.css';
import '../assets/css/datepicker.min.css';
import '../assets/css/fancybox.min.css';
import '../assets/css/swiper2.min.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style2.css';

// Import images
import diningHeaderBg from '../assets/images/aboutus/dining.jpg';

// Import components
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Dining = () => {
    const [activeTab, setActiveTab] = useState('pane-A');

    useEffect(() => {
        const handleScroll = () => {
            const scroll = window.scrollY;
            const navbar = document.querySelector(".navbarzzz");
            if (navbar) {
                if (scroll > 0) {
                    navbar.style.backgroundColor = "#722628";
                } else {
                    navbar.style.backgroundColor = "transparent";
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <div className="dining-page">
             <Helmet>
                          <meta charset="utf-8" />
                          <meta
                            name="viewport"
                            content="width=device-width, initial-scale=1, shrink-to-fit=no"
                          />
                          <meta name="theme-color" content="#722628" />
                          <title>
                          Dining | Boutique Hotels and Leisure, Sri Lanka | Oryza
                            Leisure
                          </title>
                          <meta name="author" content="Ollcode" />
                          <meta name="description" content="Beautiful Luxury and Cosy stay at Kent Cottage Nuwara-Eliya" />
                        <meta name="keywords"
                        content="hotel, room, restaurant, events, pool, nightlife, bed, matras, balcony, vacation, honeymoon, suit, premium, deluxe, penthouse, vip"/>

                        </Helmet>
            <div className="cursor js-cursor"></div>
            
            <Navbar />

            <main id="main">
                <header className="page-header" style={{ backgroundImage: `url(${diningHeaderBg})` }}>
                    <div className="container">
                        <h1>Dining</h1>
                        <p>Enjoy more, Spend less</p>
                    </div>
                    <div className="scroll-down"></div>
                </header>

                <div className="content-section kentbg_m">
                    <div className="container" id="first_section">
                        <div className="tabs_menu" data-cue="slideInUp" data-delay="200">
                            <ul className="nav nav-tabs menu-tabs" role="tablist">
                                <li className="nav-item">
                                    <a 
                                        id="tab-A" 
                                        href="#pane-A" 
                                        className={`nav-link ${activeTab === 'pane-A' ? 'active' : ''}`}
                                        onClick={() => handleTabClick('pane-A')}
                                        role="tab"
                                    >
                                        Breakfast
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a 
                                        id="tab-B" 
                                        href="#pane-B" 
                                        className={`nav-link ${activeTab === 'pane-B' ? 'active' : ''}`}
                                        onClick={() => handleTabClick('pane-B')}
                                        role="tab"
                                    >
                                        À La Carte
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a 
                                        id="tab-C" 
                                        href="#pane-C" 
                                        className={`nav-link ${activeTab === 'pane-C' ? 'active' : ''}`}
                                        onClick={() => handleTabClick('pane-C')}
                                        role="tab"
                                    >
                                        Young Traveller
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a 
                                        id="tab-D" 
                                        href="#pane-D" 
                                        className={`nav-link ${activeTab === 'pane-D' ? 'active' : ''}`}
                                        onClick={() => handleTabClick('pane-D')}
                                        role="tab"
                                    >
                                        BBQ
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content add_bottom_25" role="tablist">
                                <div id="pane-A" className={`card tab-pane fade ${activeTab === 'pane-A' ? 'show active' : ''}`} role="tabpanel" aria-labelledby="tab-A">
                                    <div className="card-header" role="tab" id="heading-A">
                                        <h5>
                                            <a 
                                                className={activeTab === 'pane-A' ? '' : 'collapsed'} 
                                                onClick={() => handleTabClick('pane-A')}
                                                href="#collapse-A" 
                                                aria-expanded={activeTab === 'pane-A'}
                                                aria-controls="collapse-A"
                                            >
                                                BREAKFAST
                                            </a>
                                        </h5>
                                    </div>
                                    <div id="collapse-A" className={`collapse ${activeTab === 'pane-A' ? 'show' : ''}`} role="tabpanel" aria-labelledby="heading-A">
                                        <div className="card-body text-center menu-content">
                                            <div className="row magnific-gallery add_top_30">
                                                <div className="col-12">
                                                    <h5 className="meal-time">FROM 7.00AM - 12.00PM</h5>
                                                </div>
                                                <div className="col-12">
                                                    <div className="menu_title">
                                                        <h3 className="meal-heading">ENGLISH BREAKFAST</h3>
                                                    </div>
                                                    <p className="meal-item">
                                                        Tropical Fresh Fruit Platter<br />
                                                        &<br />
                                                        Fresh Fruit Juice (Watermelon, Pineapple, Papaya)
                                                    </p>
                                                    <h5 className="choice-heading">CHOICE OF EGGS</h5>
                                                    <p className="meal-item">
                                                        Fried Eggs / Omelet / Scramble Eggs
                                                    </p>
                                                    <p className="meal-description">
                                                        Accompanied with Chicken Sausage, Grilled Tomato, Baked Beans, Potato, Sautéed Mushroom & Spinach
                                                    </p>
                                                    <p className="meal-item">
                                                        Served with Toast Butter Jam
                                                    </p>
                                                    <div className="menu_title">
                                                        <h3 className="meal-heading">CHOICE OF SRI LANKAN</h3>
                                                    </div>
                                                    <p className="meal-item">
                                                        String Hoppers<br />
                                                        Or<br />
                                                        Milk Rice<br />
                                                        Or<br />
                                                        Coconut Roti
                                                    </p>
                                                    <h5 className="choice-heading">CHOICE OF MEAT CURRY</h5>
                                                    <p className="meal-item">
                                                        Chicken / Fish / Prawn
                                                    </p>
                                                    <p className="meal-description">
                                                        Served with Dhal Curry, Potato White Curry & Coconut Sambal
                                                    </p>
                                                    <p className="meal-item">
                                                        Tea or Coffee
                                                    </p>
                                                </div>
                                                <div className="col-12">
                                                    <h5 className="footer-note">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div id="pane-B" className={`card tab-pane fade ${activeTab === 'pane-B' ? 'show active' : ''}`} role="tabpanel" aria-labelledby="tab-B">
                                    <div className="card-header" role="tab" id="heading-B">
                                        <h5>
                                            <a 
                                                className={activeTab === 'pane-B' ? '' : 'collapsed'} 
                                                onClick={() => handleTabClick('pane-B')}
                                                href="#collapse-B" 
                                                aria-expanded={activeTab === 'pane-B'} 
                                                aria-controls="collapse-B"
                                            >
                                                Á LA CARTE
                                            </a>
                                        </h5>
                                    </div>
                                    <div id="collapse-B" className={`collapse ${activeTab === 'pane-B' ? 'show' : ''}`} role="tabpanel" aria-labelledby="heading-B">
                                        <div className="card-body text-center menu-content">
                                            <div className="row magnific-gallery add_top_30">
                                                <div className="col-12">
                                                    <h5 className="meal-time">FROM 12.00PM - 10.00PM</h5>
                                                </div>
                                                <div className="col-12">
                                                    <div className="title text-center mb-5">
                                                        <h2 className="section-heading">APPETIZER</h2>
                                                    </div>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        CHICKEN TENDERS & SPICED DIP
                                                    </div>
                                                    <p className="item-ingredients">Chicken | Kochchi Sauce</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        GRILLED CUTTLEFISH WITH GARLIC & LEMON
                                                    </div>
                                                    <p className="item-ingredients">Cuttlefish | Garlic | Lemon | Cream</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        VEGETABLE SPRING ROLL
                                                    </div>
                                                    <p className="item-ingredients">Chicken | Kochchi Sauce</p>
                                                </div>
                                                <div className="col-12">
                                                    <div className="title text-center mb-5">
                                                        <h2 className="section-heading">SALAD</h2>
                                                    </div>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        CHICKEN CAESAR SALAD
                                                    </div>
                                                    <p className="item-ingredients">Chicken | Croutons | Ice Berg Lettuce</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        GARDEN GREENS & TROPICAL FRUITS
                                                    </div>
                                                    <p className="item-ingredients">Greens | Cucumber | Seasonal Fruits</p>
                                                </div>
                                                <div className="col-12">
                                                    <div className="title text-center mb-5">
                                                        <h2 className="section-heading">SOUPS</h2>
                                                    </div>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        CHICKEN & HERB CREAM SOUP
                                                    </div>
                                                    <p className="item-ingredients">Chicken | Sri Lankan Herbs</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        LEMONGRASS & COCONUT FLAVORED PUMPKIN SOUP
                                                    </div>
                                                    <p className="item-ingredients">Pumpkin | Lemongrass | Coconut Cream</p>
                                                </div>
                                                <div className="col-12">
                                                    <div className="title text-center mb-5">
                                                        <h2 className="section-heading">MAINS</h2>
                                                    </div>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        GRILLED BARRAMUNDI & CURRY GRAVY
                                                    </div>
                                                    <p className="item-ingredients">Barramundi | Greens | Gravy | Lemongrass Rice</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        HERB MARINATED GRILLED CHICKEN BREAST
                                                    </div>
                                                    <p className="item-ingredients">Chicken | Potato | Rocket Leaves | Herb | Red Wine Sauce</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        STIR-FRIED BEEF WITH STEAMED RICE
                                                    </div>
                                                    <p className="item-ingredients">Beef | Ginger | Bell Peppers | Steamed Rice</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        SPICED LOKU PRAWNS (BIG PRAWN) WITH FETTUCCINE
                                                    </div>
                                                    <p className="item-ingredients">Lagoon Prawns | Spiced Creamy Sauce</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        FETTUCCINE WITH CARBONARA
                                                    </div>
                                                    <p className="item-ingredients">Cripsy Bacon | Creamy Sauce | Parmesan Cheese</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        PENNE ARRABIATA
                                                    </div>
                                                    <p className="item-ingredients">Arrabiata Sauce | Parmesan Cheese</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        SRI LANKAN RICE & CURRY
                                                    </div>
                                                    <p className="item-ingredients">Four Veg Curries with Chutney and Papadam</p>
                                                    <h5 className="choice-heading">CHOICES</h5>
                                                    <p className="item-ingredients">Chicken / Prawn / Fish / Vegetable</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        FRIED RICE
                                                    </div>
                                                    <h5 className="choice-heading">CHOICES</h5>
                                                    <p className="item-ingredients">Chicken / Seafood / Egg</p>
                                                </div>
                                                <div className="col-12">
                                                    <div className="title text-center mb-5">
                                                        <h2 className="section-heading">HANDHELDS</h2>
                                                    </div>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        KENT CLUB SANDWICH
                                                    </div>
                                                    <p className="item-ingredients">Bread | Eggs | Cheese | Chicken | Ham | Lettuce | Fries</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        CRISPY CHICKEN BURGER
                                                    </div>
                                                    <p className="item-ingredients">Pumpkin | Lemongrass | Coconut Cream</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        BEEF BURGER
                                                    </div>
                                                    <p className="item-ingredients">Pumpkin | Lemongrass | Coconut Cream</p>
                                                </div>
                                                <div className="col-12">
                                                    <div className="title text-center mb-5">
                                                        <h2 className="section-heading">DESSERTS</h2>
                                                    </div>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        WARM CHOCOLATE BROWNIE
                                                    </div>
                                                    <p className="item-ingredients">Nuts | Vanilla Ice Cream</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        COFFEE CREAM CARAMEL
                                                    </div>
                                                    <p className="item-ingredients">Coffee Custard | Caramel</p>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        CHOICE OF ICE CREAM (03 SCOOPS)
                                                    </div>
                                                    <p className="item-ingredients">Vanilla | Chocolate | Strawberry</p>
                                                </div>
                                                <div className="col-12">
                                                    <h5 className="footer-note">ALL PRICES ARE IN LKR & SUBJECT TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div id="pane-C" className={`card tab-pane fade ${activeTab === 'pane-C' ? 'show active' : ''}`} role="tabpanel" aria-labelledby="tab-C">
                                    <div className="card-header" role="tab" id="heading-C">
                                        <h5>
                                            <a 
                                                className={activeTab === 'pane-C' ? '' : 'collapsed'} 
                                                onClick={() => handleTabClick('pane-C')}
                                                href="#collapse-C" 
                                                aria-expanded={activeTab === 'pane-C'} 
                                                aria-controls="collapse-C"
                                            >
                                                YOUNG TRAVELLER
                                            </a>
                                        </h5>
                                    </div>
                                    <div id="collapse-C" className={`collapse ${activeTab === 'pane-C' ? 'show' : ''}`} role="tabpanel" aria-labelledby="heading-C">
                                        <div className="card-body text-center menu-content">
                                            <div className="row magnific-gallery add_top_30">
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        MAC & CHEESE
                                                    </div>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        GRILLED SAUSAGE WITH POTATO MASHED
                                                    </div>
                                                </div>
                                                <div className="col-6 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        FRENCH FRIES WITH TARTARE SAUCE
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="pane-D" className={`card tab-pane fade ${activeTab === 'pane-D' ? 'show active' : ''}`} role="tabpanel" aria-labelledby="tab-D">
                                    <div className="card-header" role="tab" id="heading-D">
                                        <h5>
                                            <a 
                                                className={activeTab === 'pane-D' ? '' : 'collapsed'} 
                                                onClick={() => handleTabClick('pane-D')}
                                                href="#collapse-D" 
                                                aria-expanded={activeTab === 'pane-D'} 
                                                aria-controls="collapse-D"
                                            >
                                                BBQ
                                            </a>
                                        </h5>
                                    </div>
                                    <div id="collapse-D" className={`collapse ${activeTab === 'pane-D' ? 'show' : ''}`} role="tabpanel" aria-labelledby="heading-D">
                                        <div className="card-body text-center menu-content">
                                            <div className="row magnific-gallery add_top_30">
                                                <div className="col-12 menu_item_padding">
                                                    <h5 className="meal-time">MENU PER PERSON</h5>
                                                </div>
                                                <div className="col-12 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        SALAD
                                                    </div>
                                                    <p className="meal-item">Mixed Green Leaves Salad Bowl With Condiments & Dressings</p>
                                                </div>
                                                <div className="col-12 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        HOT
                                                    </div>
                                                    <p className="meal-item">Mexican Rice</p>
                                                    <p className="meal-item">Seasonal Buttered Vegetable</p>
                                                    <p className="meal-item">Baked Jacket Potato with Spiced Sour Cream</p>
                                                </div>
                                                <div className="col-12">
                                                    <div className="title text-center mb-5">
                                                        <h2 className="section-heading">ON THE GRILL</h2>
                                                    </div>
                                                </div>
                                                <div className="col-12 menu_item_padding">
                                                    <div className="menu_title menu_item_size">
                                                        SELECT BELOW THREE ITEMS
                                                    </div>
                                                    <p className="meal-item">BBQ Chicken</p>
                                                    <p className="meal-item">Lagoon Jumbo Prawns</p>
                                                    <p className="meal-item">Beef Steaks</p>
                                                    <p className="meal-item">Spiced Marinated Pork Chop</p>
                                                    <p className="meal-item">Whole Baked Fish</p>
                                                    <p className="meal-item">BBQ Sausages</p>
                                                </div>
                                                <div className="col-12">
                                                    <div className="title text-center mb-5">
                                                        <h2 className="section-heading">SAUCES</h2>
                                                    </div>
                                                </div>
                                                <div className="col-12 menu_item_padding">
                                                    <p className="meal-item">BBQ Sauce</p>
                                                    <p className="meal-item">Garlic Butter Sauce</p>
                                                    <p className="meal-item">Fresh Tomato Sauce</p>
                                                </div>
                                                <div className="col-12">
                                                    <div className="title text-center mb-5">
                                                        <h2 className="section-heading">DESSERTS</h2>
                                                    </div>
                                                </div>
                                                <div className="col-12 menu_item_padding">
                                                    <p className="meal-item">Coffee Caramel</p>
                                                    <p className="meal-item">An Assorted Fresh Cut Fruit</p>
                                                    <p className="meal-item">Tea / Coffee</p>
                                                </div>
                                                <div className="col-12">
                                                    <h5 className="footer-note">ALL PRICES ARE IN LKR &.Subject TO 10% SERVICE CHARGE + 01% GOVERNMENT TAX</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </main>

            <style jsx>{`
                .dining-page {
                    width: 100%;
                    height: 100%;
                    overflow-x: hidden;
                    overflow-y: scroll;
                    font-family: 'Jost', sans-serif;
                }
                
                .dining-page::-webkit-scrollbar {
                    display: none;
                }
                
                .dining-page {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                
                .navbarzzz {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    background-color: transparent;
                    padding: 10px 0;
                    transition: background-color 0.3s ease;
                    z-index: 1000;
                    font-family: 'Jost', sans-serif;
                }
                
                .page-header {
                    position: relative;
                    height: 60vh;
                    background-size: cover;
                    background-position: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: left;
                    color: white;
                }

                .page-header .container {
                    padding: 20px;
                    max-width: 1200px;
                    margin: 0 auto;
                }

                .page-header .container h1 {
                    width: 100%;
                    display: block;
                    font-size: 48px;
                    font-weight: 300;
                    margin-bottom: 10px;
                    line-height: 1.2;
                    font-family: "Argesta Display";
                    text-indent: 130px;
                }

                .page-header .container p {
                    font-size: 22px;
                    font-weight: 300;
                    margin: 0;
                    line-height: 1.5;
                    text-indent: 130px;
                }

                .scroll-down {
                    position: absolute;
                    bottom: 20px;
                    width: 2px;
                    height: 40px;
                    background: white;
                    margin: 0 auto;
                    left: 50%;
                    transform: translateX(-50%);
                }

                .menu-tabs {
                    border: none;
                    border-radius: 0;
                    display: flex;
                    justify-content: center;
                    background-color:rgba(114, 38, 40, 0);
                    padding: 10px 0;
                }
                
                .menu-tabs .nav-item {
                    margin: 0 10px;
                }
                
                .menu-tabs .nav-link {
                    color: #FFFFFF;
                    border: none;
                    padding: 12px 24px;
                    border-radius: 0;
                    font-weight: 500;
                    background-color: transparent;
                    transition: border-bottom 0.3s;
                    font-family: 'Jost', sans-serif;
                    font-size: 16px;
                    text-transform: uppercase;
                }
                
                .menu-tabs .nav-link.active {
                    color: #FFFFFF;
                    font-weight: 600;
                    border-bottom: 2px solid #FFFFFF;
                    background-color: transparent;
                }
                
                .menu-tabs .nav-link:hover:not(.active) {
                    color: #FFFFFF;
                    border-bottom: 2px solid #FFFFFF;
                    background-color: transparent;
                }
                
                .card {
                    border: none;
                    border-radius: 15px;
                    background-color: #efe2d2;
                }
                
                .card-header {
                    background-color: transparent;
                    border: none;
                    padding: 0;
                    display: none;
                }
                
                .card-body {
                    padding: 40px;
                }
                
                .menu-content {
                    color: #722628;
                    font-family: 'Jost', sans-serif;
                }
                
                .meal-time {
                    color: #722628;
                    margin-bottom: 30px;
                    font-family: 'Jost', sans-serif;
                    font-weight: 600;
                    font-size: 15px;
                    line-height: 23px;
                    text-transform: uppercase;
                }
                
                .meal-heading {
                    color: #722628;
                    font-family: 'Jost', sans-serif;
                    font-weight: 600;
                    font-style: normal;
                    font-size: 28px;
                    line-height: 34px;
                    margin-bottom: 20px;
                    text-transform: uppercase;
                }
                
                .choice-heading {
                    color: #722628;
                    font-family: 'Jost', sans-serif;
                    font-weight: 600;
                    font-size: 18px;
                    line-height: 18px;
                    margin: 20px 0 15px;
                    text-transform: uppercase;
                }
                
                .meal-item {
                    margin-bottom: 15px;
                    color: #722628;
                    font-family: 'Jost', sans-serif;
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 18px;
                }
                
                .meal-description {
                    margin: 20px 0;
                    color: #722628;
                    font-family: 'Jost', sans-serif;
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 18px;
                }
                
                .item-ingredients {
                    color: #722628;
                    font-family: 'Jost', sans-serif;
                    font-weight: 400;
                    font-style: italic;
                    margin-bottom: 15px;
                    font-size: 18px;
                    line-height: 18px;
                }
                
                .section-heading {
                    color: #722628;
                    font-family: 'Jost', sans-serif;
                    font-weight: 600;
                    font-size: 28px;
                    line-height: 34px;
                    margin-bottom: 20px;
                    text-transform: uppercase;
                }
                
                .menu_title {
                    margin-bottom: 10px;
                    color: #722628;
                }
                
                .menu_item_size {
                    font-family: 'Jost', sans-serif;
                    font-weight: 600;
                    font-size: 18px;
                    line-height: 18px;
                    text-transform: uppercase;
                }
                
                .menu_item_padding {
                    padding: 10px 15px;
                }
                
                .footer-note {
                    margin-top: 40px;
                    font-family: 'Jost', sans-serif;
                    font-weight: 600;
                    font-style: normal;
                    font-size: 20px;
                    line-height: 24px;
                    color: #722628;
                    text-transform: uppercase;
                }
                
                @media (max-width: 768px) {
                    .menu-tabs {
                        flex-wrap: wrap;
                        padding: 5px 0;
                    }
                    
                    .menu-tabs .nav-item {
                        margin: 5px 10px;
                    }
                    
                    .menu-tabs .nav-link {
                        padding: 10px 15px;
                        font-size: 14px;
                    }
                    
                    .page-header {
                        height: 60vh;
                        background-size: cover !important;
                        background-position: center;
                    }

                    .page-header .container h1 {
                        font-size: 1.8rem;
                        line-height: 1.2;
                        text-indent: 50px;
                    }

                    .page-header .container p {
                        font-size: 0.9rem;
                        line-height: 1.5;
                        text-indent: 50px;
                    }
                    
                    .meal-heading {
                        font-size: 24px;
                        line-height: 30px;
                    }
                    
                    .section-heading {
                        font-size: 24px;
                        line-height: 30px;
                    }
                    
                    .menu_item_size {
                        font-size: 16px;
                        line-height: 16px;
                    }
                    
                    .meal-time {
                        font-size: 14px;
                        line-height: 20px;
                    }
                    
                    .choice-heading,
                    .meal-item,
                    .meal-description,
                    .item-ingredients {
                        font-size: 16px;
                        line-height: 16px;
                    }
                    
                    .footer-note {
                        font-size: 18px;
                        line-height: 22px;
                    }
                }
            `}</style>
        </div>
    );
};

export default Dining;